/* @flow */

import _ExportReportWrapper from './ExportReportWrapper';

export default _ExportReportWrapper;



// WEBPACK FOOTER //
// ./src/components/ExportReportWrapper/index.js